import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage } from 'react-intl';
import ArrowLeftIcon from 'assets/images/WithoutLogin/arrow-left.svg';
import HospitalIcon from 'assets/images/Dashboard/doctor-hospital.svg';
import VideoCallCameraIcon from 'assets/images/Dashboard/Video_Call.svg';
import DefaultImage from 'assets/images/Dashboard/default-list.svg';
import CallIcon from 'assets/images/Dashboard/call.svg';
import MailIcon from 'assets/images/Dashboard/mail.svg';
import ClockIcon from 'assets/images/Dashboard/clock.svg';
import CalerderIcon from 'assets/images/Dashboard/calendar.svg';
import { doctorAppointments } from 'routes/AppUrls';
import rightIcon from 'assets/images/Dashboard/check.svg';
import ReusableButton from 'components/commom/Button';
import CommonModal from 'components/commom/Modal';
import LabelWithInput from 'components/commom/LabelWithInput';
import { useDispatch, useSelector } from 'react-redux';
import { getAppointmentDetail } from 'store/getAppointmentDetail/getAppointmentDetailAcition';
import moment from 'moment';
import { updateRequestDetail } from 'store/updateRequestStatus/updateRequestStatusAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import { getSuggestSlotData } from 'store/getSuggestSlot/getSuggestSlotAction';
import Shimmer from 'components/commom/Shimmer';
import MuiBreadcrumbs from 'components/commom/MuiBreadcrumbs';
import CommonToast from 'components/commom/CommonToast';
import { getMethodWithToken } from 'utils/services/apiService';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

const RequestDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const [isModal, setIsModal] = useState(false);
  const { showToast } = CommonToast();
  const [appointmentRequestDetail, setAppointmentRequestDetail] = useState('');
  const [formData, setFormData] = useState({
    start_time: '',
    end_time: '',
  });
  const [selectDate, setSelectDate] = useState('');
  const [showAvailSlot, setShowAvailSlot] = useState([]);
  const [images, setImages] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);

  const acceptReducer = useSelector(
    (state) => state?.updateRequestDetailReducer?.loading
  );

  const appointmentDetailReducer = useSelector(
    (state) => state?.getAppointmentDetailReducer?.loading
  );

  const requestId = useSelector(
    (state) => state?.basicDetailsValueReducer?.requestId
  );

  const breadcrumbsList = [
    {
      title: <FormattedMessage id="Appointments" />,
      Link: '',
      isDisbale: true,
    },
    {
      title: <FormattedMessage id="Appointment Details" />,
      Link: '',
      isDisbale: false,
    },
  ];

  useEffect(() => {
    getRequestDetail();
  }, []);

  const getRequestDetail = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        handleFetchImages(res);
        setAppointmentRequestDetail(res?.data);
        setSelectDate(
          moment(res?.data?.appointment_date_time).format('YYYY-MM-DD')
        );
        getSuggestSlotValue(
          moment(res?.data?.appointment_date_time).format('YYYY-MM-DD')
        );
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getAppointmentDetail(external, requestId));
  };

  const handleFetchImages = async (res) => {
    setImageLoading(true);
    const fetchedImages = await Promise.all(
      res?.data?.attachments?.map(async (item) => {
        const url = item.image.replace(process.env.REACT_APP_BASE_URL, '');
        const res = await getMethodWithToken(url, true);
        if (res?.status === 200 && res?.data) {
          const blob = new Blob([res.data], { type: 'image/jpeg' });
          setImageLoading(false);
          return {
            id: item.id,
            image: URL.createObjectURL(blob),
          };
        } else {
          console.error('Image fetch failed:', res?.status);
          setImageLoading(false);
          return null;
        }
      })
    );
    setImages(fetchedImages.filter(Boolean));
  };

  const getSuggestSlotValue = (date) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setShowAvailSlot(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getSuggestSlotData(external, date));
  };

  const handleAccept = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        navigate(doctorAppointments(locale));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      appointment_id: requestId,
      is_accept: true,
    };
    dispatch(updateRequestDetail(external, body));
  };

  const handleOpenSuggest = () => {
    setIsModal(true);
    getSuggestSlotValue(
      moment(appointmentRequestDetail?.appointment_date_time).format(
        'YYYY-MM-DD'
      )
    );
    setSelectDate(
      moment(appointmentRequestDetail?.appointment_date_time).format(
        'YYYY-MM-DD'
      )
    );
  };

  const handleCloseSuggest = () => {
    setIsModal(false);
  };

  const handleSelectDate = (value) => {
    setSelectDate(value);
    getSuggestSlotValue(value);
  };
  const [selectIndex, setSelectIndex] = useState('');

  const handleSelectTime = (value, index) => {
    setFormData((prevState) => ({
      ...prevState,
      start_time: value?.slot_start,
      end_time: value?.slot_end,
    }));
    setSelectIndex(index);
  };

  const handleSaveSuggest = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        setIsModal(false);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      appointment_id: requestId,
      is_reschedule: true,
      suggested_consultation_date: selectDate,
      suggested_consultation_start_time: formData?.start_time,
      suggested_consultation_end_time: formData?.end_time,
    };
    dispatch(updateRequestDetail(external, body));
  };

  return (
    <Row className="bc-FEF9F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="12" list={breadcrumbsList} />

        <div className="mt-10">
          <Row className="bc-FFFFFF p-24 border-1 bColor-EFE3D7 m-0">
            <Col xs={12} md={12} className="p-0">
              <Stack direction="horizontal" gap={2} className="items-center">
                <img
                  src={ArrowLeftIcon}
                  alt="icon"
                  style={{ height: '24px', width: '24px' }}
                  className="cursor-pointer"
                  onClick={() => navigate(doctorAppointments(locale))}
                />
                {appointmentDetailReducer ? (
                  <Shimmer width="250px" height="20px" />
                ) : (
                  <div className="fs-16 lh-16 fc-292D32 family_outfit_medium_500">
                    <FormattedMessage id="Appointment no." />
                    {appointmentRequestDetail?.booking_id}
                  </div>
                )}
              </Stack>
            </Col>

            <Col
              xs={12}
              md={12}
              className="mt-4 border-b pb-4 p-0 bColor-D6DDE6"
            >
              <Row>
                <Col md={12}>
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="flex items-start"
                  >
                    {appointmentDetailReducer ? (
                      <Shimmer width="88px" height="88px" borderRadius="50%" />
                    ) : (
                      <Image
                        src={
                          appointmentRequestDetail?.patient?.profile_pic !== ''
                            ? appointmentRequestDetail?.patient?.profile_pic
                            : DefaultImage
                        }
                        alt={'icon'}
                        style={{
                          height: '88px',
                          width: '88px',
                          borderRadius: '50%',
                        }}
                      />
                    )}
                    <div>
                      <div className="fs-18 lh-2268 fc-202224 family_outfit_medium_500">
                        {appointmentDetailReducer ? (
                          <Shimmer width="150px" height="20px" />
                        ) : (
                          appointmentRequestDetail?.patient?.full_name
                        )}
                      </div>
                      <div className="pt-12 fs-14 fc-998A7B family_outfit_regular_400">
                        ID:
                        <span className="fc-3C3C3C family_outfit_medium_500">
                          {appointmentRequestDetail?.patient?.patient_id}
                        </span>
                      </div>
                      <div>
                        <Stack
                          direction="horizontal"
                          gap={5}
                          className="items-center pt-12"
                        >
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center"
                          >
                            {appointmentDetailReducer ? (
                              <Shimmer width="250px" height="20px" />
                            ) : (
                              <>
                                <Image src={CallIcon} alt="icon" />
                                <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400">
                                  {`${appointmentRequestDetail?.patient?.country_code} ${appointmentRequestDetail?.patient?.contact_number}`}
                                </div>
                              </>
                            )}
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center"
                          >
                            {appointmentDetailReducer ? (
                              <Shimmer width="250px" height="20px" />
                            ) : (
                              <>
                                <Image src={MailIcon} alt="icon" />
                                <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400">
                                  {appointmentRequestDetail?.patient?.email}
                                </div>
                              </>
                            )}
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  </Stack>
                </Col>
              </Row>
            </Col>

            <Col xs={12} md={12} className="p-0">
              <div className="pt-15">
                <Row className="p-0">
                  <Col
                    xs={12}
                    md={12}
                    lg={7}
                    xl={7}
                    className="flex items-center"
                  >
                    <Stack
                      direction="horizontal"
                      gap={5}
                      className="items-center"
                    >
                      <Stack
                        direction="horizontal"
                        gap={1}
                        className="flex items-center"
                      >
                        <div className="fs-16 lh-201 fc-998A7B family_outfit_regular_400">
                          Modality:
                        </div>
                        <div>
                          <Image
                            src={
                              appointmentRequestDetail?.consultation_type ===
                              'Hospital Visit'
                                ? HospitalIcon
                                : VideoCallCameraIcon
                            }
                            alt="icon"
                          />
                        </div>
                        <div className="fs-16 lh-201 fc-292D32 family_outfit_medium_500">
                          {appointmentDetailReducer ? (
                            <Shimmer width="120px" height="20px" />
                          ) : (
                            appointmentRequestDetail?.consultation_type
                          )}
                        </div>
                      </Stack>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <Image src={CalerderIcon} alt="icon" />
                        {appointmentDetailReducer ? (
                          <Shimmer width="250px" height="20px" />
                        ) : (
                          <div className="fs-16 lh-201 fc-292D32 family_outfit_medium_500">
                            {moment(
                              appointmentRequestDetail?.appointment_date_time
                            ).format('MMMM D, YYYY')}
                          </div>
                        )}
                      </Stack>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <Image src={ClockIcon} alt="icon" />
                        {appointmentDetailReducer ? (
                          <Shimmer width="250px" height="20px" />
                        ) : (
                          <div className="fs-16 lh-201 fc-292D32 family_outfit_medium_500">
                            {moment(
                              appointmentRequestDetail?.appointment_date_time
                            ).format('hh:mmA')}
                          </div>
                        )}
                      </Stack>
                    </Stack>
                  </Col>
                  <Col
                    xs={12}
                    md={12}
                    lg={5}
                    xl={5}
                    className="flex justify-end"
                  >
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center justify-end p-0"
                    >
                      <ReusableButton
                        fullWidth={false}
                        variant="outlined"
                        color="#864629"
                        fontSize="14px"
                        fontWeight="500"
                        padding="12px 20px"
                        height="40px"
                        bgColor="transparent"
                        brColor="#EFE3D7"
                        fontFamily="outfit_medium"
                        onClick={() => handleOpenSuggest()}
                      >
                        <FormattedMessage id="Suggest another slot" />
                      </ReusableButton>

                      <ReusableButton
                        fullWidth={false}
                        variant="contained"
                        color="#F5F5F5"
                        fontSize="14px"
                        fontWeight="500"
                        padding="12px 20px"
                        height="40px"
                        bgColor="#864629"
                        brColor="#375241"
                        fontFamily="outfit_medium"
                        onClick={() => {
                          !acceptReducer && handleAccept();
                        }}
                        loading={acceptReducer}
                      >
                        <img
                          src={rightIcon}
                          alt="icon"
                          style={{ height: '18px', width: '18px' }}
                          className="me-2"
                        />
                        <FormattedMessage id="Accept Request" />
                      </ReusableButton>
                    </Stack>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>

        <div className="mt-16">
          <Row className="bc-FFFFFF p-24 border-1 bColor-EFE3D7 m-0">
            <Col xs={12} md={6} className="p-0">
              <div className="fs-16 lh-252  fc-292D32 family_outfit_medium_500">
                <FormattedMessage id="Patient’s form" />
              </div>
              <div className="fs-14 lh-176 fc-998A7B family_outfit_regular_400 pt-24">
                <FormattedMessage id="Symptoms" />
              </div>
              <div className="fs-16 lh-201 fc-3C3C3C pt-04 family_outfit_regular_400">
                {appointmentDetailReducer ? (
                  <Shimmer width="250px" height="20px" />
                ) : (
                  appointmentRequestDetail?.symptoms &&
                  appointmentRequestDetail?.symptoms.length > 0 &&
                  appointmentRequestDetail.symptoms
                    .map((item) => item?.name)
                    .filter((name) => name)
                    .join(', ')
                )}
              </div>

              {appointmentRequestDetail?.attachments &&
                appointmentRequestDetail?.attachments.length > 0 && (
                  <>
                    <div className="mt-4 fs-14 lh-176 fc-998A7B family_outfit_regular_400">
                      <FormattedMessage id="Attachments" />
                    </div>

                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center pt-04"
                    >
                      {imageLoading ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        <>
                          {images?.map((item, i) => {
                            return (
                              <>
                                <Zoom>
                                  <Image
                                    key={item?.id}
                                    src={item?.image}
                                    alt="icon"
                                    style={{
                                      height: '130px',
                                      width: '130px',
                                      boxShadow:
                                        'rgba(0, 0, 0, 0.2) 0px 1px 1px 0px, rgba(0, 0, 0, 0.19) 0px 1px 5px 0px',
                                    }}
                                  />
                                </Zoom>
                              </>
                            );
                          })}
                        </>
                      )}
                    </Stack>
                  </>
                )}

              <div className="mt-4 fs-14 lh-176 fc-998A7B family_outfit_regular_400">
                <FormattedMessage id="Description" />
              </div>
              <div className="pt-04 fs-16 lh-201 fc-3C3C3C family_outfit_regular_400">
                {appointmentDetailReducer ? (
                  <Shimmer width="100%" height="20px" />
                ) : (
                  appointmentRequestDetail?.description
                )}
              </div>
            </Col>

            <Col xs={12} md={6} className="p-0 mt-md-0 mt-3">
              <div className="fs-16 lh-252 fc-292D32 family_outfit_medium_500">
                <FormattedMessage id="Medical History" />
              </div>
              {appointmentRequestDetail?.medical_history &&
                appointmentRequestDetail?.medical_history.length > 0 &&
                appointmentRequestDetail?.medical_history.map((item, index) => {
                  return (
                    <>
                      <div className="fs-14 lh-176 fc-998A7B family_outfit_regular_400 pt-24">
                        {appointmentDetailReducer ? (
                          <Shimmer width="100%" height="20px" />
                        ) : (
                          item?.question
                        )}
                      </div>
                      <div className="pt-04 fs-16 lh-201 fc-3C3C3C  family_outfit_regular_400">
                        {appointmentDetailReducer ? (
                          <Shimmer width="250px" height="20px" />
                        ) : (
                          item?.answer
                        )}
                      </div>
                    </>
                  );
                })}
            </Col>
          </Row>
        </div>
      </Col>

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={isModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="fs-24 lh-3024 fc-292D32 family_outfit_semiBold_600">
                  Suggest another slot
                </div>

                <Row className="m-0 p-0">
                  <Col md={12} lg={12} className="mt-3 p-0">
                    <LabelWithInput
                      label="Date"
                      type="date"
                      value={selectDate}
                      onChange={(e) => handleSelectDate(e.target.value)}
                    />
                  </Col>

                  <Col md={12} className="p-0">
                    {showAvailSlot?.availability &&
                      showAvailSlot?.availability.length > 0 && (
                        <>
                          <div className="fs-14 family_outfit_medium_500 lh-176 fc-292D32 pt-16">
                            Start Time
                          </div>
                          <div className="flex flex-wrap">
                            {showAvailSlot?.availability.map((item, index) => {
                              return (
                                item?.available === true && (
                                  <div
                                    className="slot-box mr-10 mt-10 cursor-pointer ..."
                                    onClick={() =>
                                      handleSelectTime(item, index)
                                    }
                                    style={{
                                      border:
                                        selectIndex === index
                                          ? '1px solid #C56616'
                                          : '1px solid #efe3d7',
                                    }}
                                  >
                                    {item?.slot_start}
                                  </div>
                                )
                              );
                            })}
                          </div>
                        </>
                      )}
                  </Col>

                  <Col xs={12} md={12} className="mt-3 p-0 flex justify-end">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center justify-end p-0"
                    >
                      <ReusableButton
                        fullWidth={false}
                        variant="outlined"
                        color="#3C3C3C"
                        fontSize="14px"
                        fontWeight="500"
                        padding="12px 50px"
                        height="44px"
                        bgColor="transparent"
                        brColor="#EFE3D7"
                        fontFamily="outfit_medium"
                        onClick={() => handleCloseSuggest()}
                      >
                        <FormattedMessage id="Cancel" />
                      </ReusableButton>

                      <ReusableButton
                        fullWidth={false}
                        variant="contained"
                        color="#F5F5F5"
                        fontSize="14px"
                        fontWeight="500"
                        padding="12px 50px"
                        height="44px"
                        bgColor="#375241"
                        brColor="#375241"
                        fontFamily="outfit_medium"
                        onClick={() => {
                          !acceptReducer && handleSaveSuggest();
                        }}
                        loading={acceptReducer}
                      >
                        <FormattedMessage id="Done" />
                      </ReusableButton>
                    </Stack>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        }
      />
    </Row>
  );
};

export default RequestDetails;
